<template>
  <div class="message-page" :style="{ height: pageHeight }">
    <!-- 留言输入框 -->
    <div class="message-container">
      <h1 class="message-title">留言墙</h1>
      <div class="animated fadeInUp message-input-wrapper">
        <input
          v-model="messageContent"
          @click="show = true"
          placeholder="留下你的足迹..."
          maxlength="200"
        />
        <button
          class="ml-3"
          @click="submitMessage"
          v-show="show"
        >
          发送
        </button>
      </div>
    </div>
    <!-- 弹幕列表 -->
    <div class="barrage-container">
      <vue-baberrage :barrageList="barrageList" :loop="false">
        <template v-slot:default="slotProps">
          <span 
            class="barrage-items" 
            :class="{ 'barrage-new': slotProps.item.isNew }"
            :style="{ background: slotProps.item.color }"
          >
            <span v-if="slotProps.item.isNew" class="new-badge">NEW</span>
            <span>{{ slotProps.item.username }} :</span>
            <span class="ml-2">{{ slotProps.item.messageContent }}</span>
          </span>
        </template>
      </vue-baberrage>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)

export default {
  name: 'Message',
  data() {
    return {
      show: false,
      messageContent: '',
      barrageList: [],
      user: null,
      // 10种不同的弹幕颜色
      barrageColors: [
        'rgba(79, 70, 229, 0.9)',   // 靛蓝色
        'rgba(239, 68, 68, 0.9)',   // 红色
        'rgba(34, 197, 94, 0.9)',   // 绿色
        'rgba(249, 115, 22, 0.9)',  // 橙色
        'rgba(168, 85, 247, 0.9)',  // 紫色
        'rgba(236, 72, 153, 0.9)',  // 粉色
        'rgba(14, 165, 233, 0.9)',  // 天蓝色
        'rgba(234, 179, 8, 0.9)',   // 黄色
        'rgba(20, 184, 166, 0.9)',  // 青色
        'rgba(244, 63, 94, 0.9)'    // 玫红色
      ]
    }
  },
  computed: {
    // 动态计算页面高度
    pageHeight() {
      // 如果是 /helper/messageWall 路径，减去 118px（Helper布局的导航栏高度）
      // 如果是 /message 路径，减去 152px（Front布局的导航栏高度 + Footer高度）
      if (this.$route.path === '/helper/messageWall') {
        return 'calc(100vh - 118px)'
      } else {
        return 'calc(100vh - 152px)'
      }
    }
  },
  created() {
    // 获取用户信息
    const userStr = localStorage.getItem('user')
    this.user = userStr ? JSON.parse(userStr) : null
  },
  mounted() {
    this.loadMessages()
    // 定时刷新留言列表（每30秒）
    this.timer = setInterval(() => {
      this.loadMessages()
    }, 50000)
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    // 加载所有留言
    loadMessages() {
      this.request.get('/message').then(res => {
        if (res.code === '200' && res.data) {
          // 转换为弹幕格式
          this.barrageList = res.data.map(item => ({
            id: item.id,
            username: item.username || '匿名用户',
            messageContent: item.messageContent,
            time: item.time || Math.floor(Math.random() * 9 + 12), // 12-20秒，滚动更慢
            color: this.getRandomColor() // 随机分配颜色
          }))
        }
      }).catch(err => {
        console.error('加载留言失败:', err)
      })
    },
    
    // 获取随机颜色
    getRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.barrageColors.length)
      return this.barrageColors[randomIndex]
    },
    
    // 提交留言
    submitMessage() {
      // 检查是否登录
      if (!this.user || !this.user.username) {
        this.$message.warning('请先登录后再留言')
        return
      }

      // 检查留言内容
      if (!this.messageContent || this.messageContent.trim() === '') {
        this.$message.warning('留言内容不能为空')
        return
      }

      if (this.messageContent.trim().length < 2) {
        this.$message.warning('留言内容至少需要2个字符')
        return
      }

      if (this.messageContent.trim().length > 200) {
        this.$message.warning('留言内容不能超过200个字符')
        return
      }

      // 构造留言数据
      const message = {
        username: this.user.username,
        messageContent: this.messageContent.trim(),
        status: 2, // 直接显示，不需要审核
        time: Math.floor(Math.random() * 9 + 12) // 弹幕滚动时间（12-20秒）
      }

      // 提交留言
      this.request.post('/message', message).then(res => {
        if (res.code === '200') {
          this.$message.success('留言发送成功')
          
          // 立即添加新留言到弹幕列表（标记为新留言）
          const newBarrageItem = {
            id: res.data || Date.now(), // 使用返回的ID或时间戳
            username: this.user.username,
            messageContent: this.messageContent.trim(),
            time: message.time,
            color: this.getRandomColor(),
            isNew: true // 标记为新留言
          }
          
          // 添加到弹幕列表开头
          this.barrageList.unshift(newBarrageItem)
          
          // 10秒后移除新留言标记
          setTimeout(() => {
            const index = this.barrageList.findIndex(item => item.id === newBarrageItem.id)
            if (index !== -1) {
              this.barrageList[index].isNew = false
              // 强制更新视图
              this.$set(this.barrageList, index, { ...this.barrageList[index] })
            }
          }, 10000)
          
          this.messageContent = ''
          this.show = false
        } else {
          this.$message.error(res.msg || '留言提交失败')
        }
      }).catch(err => {
        console.error('提交留言失败:', err)
        this.$message.error('留言提交失败，请稍后重试')
      })
    }
  }
}
</script>

<style scoped>
.message-page {
  position: relative;
  width: 100%;
  /* height 现在通过内联样式动态设置 */
  background: #fff;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
  overflow: hidden;
  animation: header-effect 1s;
}

@keyframes header-effect {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-title {
  color: #4f46e5;
  font-size: 48px;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  animation: title-scale 1s;
  margin: 0;
}

@keyframes title-scale {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.message-container {
  position: absolute;
  width: 500px;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 5;
}

.message-input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  margin-top: 2rem;
}

.message-input-wrapper input {
  outline: none;
  width: 70%;
  border-radius: 20px;
  height: 100%;
  padding: 0 1.25rem;
  color: #333;
  background: #fff;
  border: #4f46e5 2px solid;
  font-size: 14px;
  transition: all 0.3s;
}

.message-input-wrapper input:focus {
  border-color: #4338ca;
  box-shadow: 0 0 15px rgba(79, 70, 229, 0.3);
}

.message-input-wrapper input::-webkit-input-placeholder {
  color: #999;
}

.message-input-wrapper button {
  outline: none;
  border-radius: 20px;
  height: 100%;
  padding: 0 1.5rem;
  border: none;
  background: #4f46e5;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.message-input-wrapper button:hover {
  background: #4338ca;
  transform: scale(1.05);
}

.barrage-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.barrage-items {
  border-radius: 100px;
  color: #fff;
  padding: 8px 20px;
  align-items: center;
  display: flex;
  font-size: 14px;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  /* 移除固定背景色，改为动态绑定 */
  position: relative;
  transition: all 0.3s ease;
}

/* 新留言特殊样式 */
.barrage-items.barrage-new {
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.8), 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(255, 215, 0, 0.9);
  font-weight: bold;
  transform: scale(1.1);
}

/* NEW 标签样式 - 右上角定位 */
.new-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #ffd700, #ffed4e);
  color: #000;
  font-size: 10px;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.6);
  z-index: 10;
}

.ml-2 {
  margin-left: 8px;
}

.ml-3 {
  margin-left: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .message-container {
    width: 90%;
  }
  
  .message-title {
    font-size: 36px;
  }
  
  .message-input-wrapper input {
    width: 60%;
  }
}

/* 动画类 */
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.fadeInUp {
  animation-name: fadeInUp;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
